import { render } from "./StoreFeatures.vue?vue&type=template&id=0e9ae7ed&scoped=true&bindings={\"items\":\"data\"}"
import script from "./StoreFeatures.vue?vue&type=script&lang=js"
export * from "./StoreFeatures.vue?vue&type=script&lang=js"

import "./StoreFeatures.vue?vue&type=style&index=0&id=0e9ae7ed&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e9ae7ed"

export default script